import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../../components/layout";
import { ReduxConnect } from "../../../toolkit/decorators/Artifact";
import {
  ExternosListDispatcher,
  externosListDispatcher
} from "./ExternosList.dispatcher";
import { ExternosListStore, externosListStore } from "./ExternosList.store";
import ExternosListComponent from "../../components/externoList";

interface Props extends ExternosListStore, ExternosListDispatcher {}
interface State {}

@ReduxConnect(externosListStore, externosListDispatcher)
export default class ExternosListContainer extends React.Component<
  Props,
  State
> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Externos" />
          <ExternosListComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
